<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
    <el-form-item :label="$t('licenca')" v-if="userType === '1'">
      <CustomerList v-model="ruleForm.license" :customerType="2" :multiple="false" @selected="license" />
    </el-form-item>
    <el-form-item :label="$t('cliente')">
      <CustomerLicenseList v-model="ruleForm.customer" :customer="ruleForm.license" :multiple="true" @selected="list" />
    </el-form-item>
    <MessageAddTableUsers ref="tableUsers" />
  </el-form>
</template>

<script>
import CustomerLicenseList from "@/xpost/views/register/customer/CustomerLicenseList";
import CustomerList from "@/xpost/views/register/customer/CustomerList";
import MessageAddTableUsers from "./MessageAddTableUsers.vue";

export default {
  name: 'MessageAddUsersLicence',
  components: {
    CustomerList,
    CustomerLicenseList,
    MessageAddTableUsers
  },
  props: ["userType"],
  data: function () {
    return {
      ruleForm: {
        customer: [],
        name: [],
        license: '',
      },
      name: '',
      tableData: [],
    };
  },
  methods: {
    license(data, name) {
      this.name = name;
      this.ruleForm.customer = [];
    },
    get() {
      const vm = this;
      const userSeleteds = this.$refs.tableUsers.get();
      if (userSeleteds.length > 0) {
        return userSeleteds.map(x => {
          return {
            type: 'user',
            value: x.id,
            label: x.name,
          }
        })
      } else if (this.ruleForm.license === '' && this.ruleForm.customer.length === 0) {
        return [{ type: 'customer', value: 'customer', label: "Todos os clientes" }]
      } else if (this.ruleForm.license && this.ruleForm.customer.length === 0) {
        return [{ type: 'customer', value: this.ruleForm.license, label: "Todos os clientes da licença " + vm.name }]
      } else {
        return this.ruleForm.customer.map((x, index) => {
          return {
            type: 'customer',
            value: x,
            label: vm.ruleForm.name[index]
          }
        });
      }
    },
    list(customer, name) {
      this.ruleForm.name = name;
      this.$refs.tableUsers.show(customer, '1')
    }
  }
};
</script>